/**
 * Toast that fires when Foundry auto-seeds a fresh quick-batch interview
 * for a game that has no existing build session. Sky tone (not red) so
 * the user reads it as "Foundry did the right thing for me" rather than
 * a failure. Auto-dismissed after 8s by the parent — no close button by design.
 *
 * Exported so the Storybook story can render each state without mounting
 * the full Workspace.
 */
export function AutoSeededToast({
  message,
  newUi = false,
}: {
  message: string;
  newUi?: boolean;
}): React.JSX.Element {
  return (
    <div
      data-testid="auto-seeded-banner"
      role="status"
      className={
        newUi
          ? 'fixed right-4 top-28 z-40 max-w-sm rounded-xl px-4 py-3 f-body shadow-lg'
          : 'fixed right-4 top-28 z-40 max-w-sm rounded-lg border border-sky-500/30 bg-sky-900/80 px-4 py-3 text-sm text-sky-100 shadow-lg backdrop-blur-sm'
      }
      style={
        newUi
          ? {
              background: 'var(--bg-elev-3)',
              boxShadow: 'var(--hairline), 0 8px 32px rgba(0,0,0,0.5)',
              color: 'var(--text-1)',
              borderLeft: '3px solid rgba(56, 189, 248, 0.6)',
            }
          : undefined
      }
    >
      {message}
    </div>
  );
}
